// Actions only describe what happened,
// but don't describe how the application's state changes.

/*  name each action (constant) as <NOUN>_<VERB> with the present tense: TODO_ADD
action creator name: <verb><Noun>: addTodo
selector name: get<Noun> */

export const setUserStatus = status => ( {
	type: 'USER_STATUS_SET',
	status,
} );



// WEBPACK FOOTER //
// ./src/actions/user-actions.js